import Column from "@amzn/meridian/column";
import Divider from "@amzn/meridian/divider";
import Link from "@amzn/meridian/link";
import Text from "@amzn/meridian/text";
import Theme from "@amzn/meridian/theme";
import { observer } from "mobx-react-lite";
import React from "react";

import { footerConstants, FooterModalData } from "../constants/Footer";
import { IFooterMobileProps } from "../types/Footer.types";
import { FooterTokens } from "../utils/Tokens";

const { buttonBackgroundColorSecondaryDefault } = FooterTokens;
const { SMARTBIZ_BY_AMAZON } = FooterModalData;

const FooterMobile = ({spacingInset}: IFooterMobileProps) => {
  
  return (
    <Column spacing="450" spacingInset={spacingInset || "200 none 450"} data-testid="footermobile-container-column">
      <Theme
        tokens={{ dividerColor: buttonBackgroundColorSecondaryDefault }}
      >
        <Divider />
      </Theme>
      {footerConstants.map(({ title, link, onClick }) => (
        <Link target="blank" href={link} onClick={onClick} key={title} type="secondary"
          data-testid={`footermobile-${title.toLowerCase().replace(/\s+/g, "-")}-link`}
        >
          <Text 
            type="b200"
            data-testid={`footermobile-${title.toLowerCase().replace(/\s+/g, "-")}-text`}
          >
            {title}
          </Text>
        </Link>
      ))}
      <Text type="b200" data-testid="footermobile-smartbiz-text">{SMARTBIZ_BY_AMAZON}</Text>
    </Column>
  );
};
export default observer(FooterMobile);
